module.exports = __webpack_public_path__ + "static/img/me.de4d120.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/me.png
// module id = bduj
// module chunks = 1